import Vuex, { createStore } from "vuex";
import VuexPersistence from 'vuex-persist';
import IGlobalState from '@/interfaces/IGlobalState';
import state        from './state';
import getters      from './getters';
import mutations    from './mutations';
import actions      from './actions';


// Ustawienia wartosci w localStorage dla wczytywania domyslnych ustawien z api
!localStorage.getItem('defaultSettings')
  ? localStorage.setItem('defaultSettings', 'true')
  : localStorage.setItem('defaultSettings', 'false');

const vuexLocal = new VuexPersistence<IGlobalState>({
  storage: window.localStorage,
  reducer: (reducedState: IGlobalState) => ({
    contrast: reducedState.contrast,
    currentLang: reducedState.currentLang,
    settings: {
      map: reducedState.settings.map,
      mapPoiLayers: reducedState.settings.mapPoiLayers,
      mapEventLayers: reducedState.settings.mapEventLayers,
    },
  }),
});

export default createStore<IGlobalState>({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocal.plugin],
});


// export default new Vuex.Store({
//   state,
//   getters,
//   mutations,
//   actions,
//   plugins: [vuexLocal.plugin],
// });
